import React, { useState } from 'react';
import { RiMapPinLine as MapPin, RiMailLine as Mail, RiPhoneLine as Phone } from '@remixicon/react';
import SocialIcons from '../common/SocialIcons';
import { useTheme } from '../../context/ThemeContext.tsx';

const Footer = () => {
    const { isDark } = useTheme();
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const handleSubscribe = () => {
        if (email.trim()) { setSent(true); setTimeout(() => setSent(false), 3000); setEmail(''); }
    };
    const groups = [
        { title: 'Páginas', links: [{ href: '/', label: 'Inicio' }, { href: '/nosotros', label: 'Nosotros' },
            { href: '/servicios', label: 'Servicios' }, { href: '/contacto', label: 'Contáctanos' }, { href: '/blog', label: 'Blog' }] },
        { title: 'Legal', links: [{ href: '/faq', label: 'Preguntas frecuentes' }, { href: '/terminos', label: 'Términos de uso' },
            { href: '/privacidad', label: 'Privacidad' }, { href: '/soporte', label: 'Soporte' }] },
    ];
    return <footer className={`comarca-footer${isDark ? ' comarca-footer-dark' : ''}`}>
        <style>{`
            .comarca-footer { --cf-bg:#faf9fc; --cf-ink:#302639; --cf-muted:#6e6577;
                --cf-line:#e8e2ed; --cf-accent:#61257b; --cf-surface:#fff;
                background:var(--cf-bg); color:var(--cf-ink); border-top:1px solid var(--cf-line);
                font-family:'DM Sans',sans-serif; }
            .comarca-footer-dark { --cf-bg:#17111f; --cf-ink:#f1edf5; --cf-muted:#b9aec5;
                --cf-line:#32273d; --cf-accent:#d6b9e6; --cf-surface:#211929; }
            .comarca-footer .cf-wrap { max-width:1200px; margin:auto; padding:56px 32px 0; }
            .comarca-footer .cf-grid { display:grid; grid-template-columns:1.6fr 1fr 1fr 1.4fr; gap:36px; padding-bottom:40px; }
            .comarca-footer .cf-logo { font-size:1.35rem; font-weight:900; letter-spacing:.04em; color:var(--cf-accent); }
            .comarca-footer .cf-logo span { font-size:.8rem; letter-spacing:.15em; display:block; margin-top:3px; font-weight:600; }
            .comarca-footer p { color:var(--cf-muted); font-size:.88rem; line-height:1.8; margin:16px 0; }
            .comarca-footer h6 { color:var(--cf-ink); font-size:.82rem; font-weight:700; margin:0 0 18px; }
            .comarca-footer ul { list-style:none; padding:0; margin:0; }
            .comarca-footer li { margin-bottom:10px; }
            .comarca-footer a { color:var(--cf-muted); font-size:.88rem; text-decoration:none; transition:color .2s; }
            .comarca-footer a:hover { color:var(--cf-accent); }
            .comarca-footer a:focus-visible,.comarca-footer button:focus-visible,.comarca-footer input:focus-visible {
                outline:2px solid var(--cf-accent); outline-offset:3px; }
            .comarca-footer .cf-subscribe { display:flex; gap:8px; margin-top:10px; }
            .comarca-footer input { min-width:0; width:100%; background:var(--cf-surface); border:1px solid var(--cf-line);
                border-radius:10px; padding:10px 12px; color:var(--cf-ink); font:inherit; font-size:.85rem; }
            .comarca-footer .cf-subscribe button { border:0; background:#61257b; color:#fff; padding:10px 16px;
                border-radius:10px; font-size:.85rem; font-weight:600; cursor:pointer; }
            .comarca-footer .cf-label { color:var(--cf-muted); font-size:.78rem; }
            .comarca-footer .cf-contact { display:flex; gap:10px; align-items:flex-start; color:var(--cf-muted);
                font-size:.86rem; line-height:1.7; margin-bottom:12px; overflow-wrap:anywhere; }
            .comarca-footer .cf-contact svg { flex-shrink:0; color:var(--cf-accent); margin-top:3px; }
            .comarca-footer .cf-bottom { display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap;
                gap:14px; padding:20px 0; border-top:1px solid var(--cf-line); }
            .comarca-footer .cf-bottom p { margin:0; font-size:.78rem; }
            .comarca-footer .cf-bottom nav { display:flex; gap:18px; }
            .comarca-footer .cf-bottom a { font-size:.78rem; }
            @media(max-width:1000px) { .comarca-footer .cf-grid { grid-template-columns:1fr 1fr; gap:32px; } }
            @media(max-width:540px) { .comarca-footer .cf-grid { grid-template-columns:1fr; gap:28px; }
                .comarca-footer .cf-wrap { padding:36px 22px 0; } }
        `}</style>
        <div className="cf-wrap">
            <div className="cf-grid">
                <div>
                    <div className="cf-logo">CO MARCA<span>GROUP</span></div>
                    <p>Espacios diseñados para impulsar tu crecimiento profesional. Conecta con una comunidad de emprendedores en el corazón de La Paz, Bolivia.</p>
                    <label htmlFor="footer-newsletter" className="cf-label">Suscríbete al newsletter</label>
                    <form className="cf-subscribe" onSubmit={event => { event.preventDefault(); handleSubscribe(); }}>
                        <input id="footer-newsletter" type="email" required placeholder="tu@email.com" value={email} onChange={event => setEmail(event.target.value)} />
                        <button type="submit">{sent ? '✓' : 'Enviar'}</button>
                    </form>
                </div>
                {groups.map(group => <nav key={group.title} aria-label={group.title}>
                    <h6>{group.title}</h6><ul>{group.links.map(item => <li key={item.href}><a href={item.href}>{item.label}</a></li>)}</ul>
                </nav>)}
                <div>
                    <h6>Contacto</h6>
                    <div className="cf-contact"><MapPin size={17} /><span>Calle 23 de Calacoto, La Paz, Bolivia</span></div>
                    <div className="cf-contact"><Mail size={17} /><a href="mailto:comarca@gmail.com">comarca@gmail.com</a></div>
                    <div className="cf-contact"><Phone size={17} /><a href="tel:+59176204601">+591 762 04601</a></div>
                    <p className="cf-label">Síguenos</p>
                    <SocialIcons align="left" variant={isDark ? 'dark' : 'light'} buttonSize={36} iconSize={18} gap={8} />
                </div>
            </div>
            <div className="cf-bottom">
                <p>© {new Date().getFullYear()} <strong>CO MARCA GROUP</strong>. Todos los derechos reservados.</p>
                <nav aria-label="Información legal"><a href="/terminos">Términos</a><a href="/privacidad">Privacidad</a><a href="/soporte">Soporte</a></nav>
            </div>
        </div>
    </footer>;
};

export default Footer;
